import { useEffect } from "react";
import useDetectKeelMind from "./useDetectKeelMind";

function usePageTitle(title) {
    const isKeelMind = useDetectKeelMind();

    useEffect(() => {
        document.title =
            title + ` | ${isKeelMind ? "Keel Mind" : "Keel Digital Solutions"}`;
    }, [title, isKeelMind]);

    return null;
}

export default usePageTitle;
